/**系统信息*/
export class SystemInfo {
  /**站点标题*/
  webTitle?: string | null | undefined = null;
  /**站点副标题*/
  webSubTitle?: string | null | undefined = null;
  /**网站图标*/
  favicon?: string | null | undefined = null;
  /**站点URL*/
  siteUrl?: string | null | undefined = null;
  /**小程序URL*/
  appUrl?: string | null | undefined = null;
  /**管理站点URL*/
  manageSiteUrl?: string | null | undefined = null;
  /**备案号*/
  registration?: string | null | undefined = null;
  /**公安备案号*/
  publicSecurityRegistration?: string | null | undefined = null;
  /**客服电话*/
  phone?: string | null | undefined = null;
  /**工作时间*/
  gzsj?: string | null | undefined = null;
  /**招商电话*/
  zsdh?: string | null | undefined = null;
  /**联系地址*/
  lxdz?: string | null | undefined = null;
  /**电子邮箱*/
  email?: string | null | undefined = null;
}
